import { render, staticRenderFns } from "./EmbedForm.vue?vue&type=template&id=73ab8c2e&"
import script from "./EmbedForm.vue?vue&type=script&lang=js&"
export * from "./EmbedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports